import { CustomSettingGuard } from '@components/customSettingGuard';
import { ProtectedRoute } from '@components/protectedRoute';
import { appRoutes, jobIdRoute } from '@utils/consts';
import { WorkProgress } from './_id/workProgress';
import { Outlet } from 'react-router';
import { jobWorkflowsRoutes, workflowsRoutes } from '@pages/panel/workflows/routes';
import { tenantsRoute } from '@utils/consts';

export const jobsRoutes = [
  {
    path: appRoutes.jobs,
    lazy: async () => {
      return {
        Component: () => (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        path: '',
        lazy: async () => {
          const { Jobs } = await import('@pages/jobs');
          const { JobsProvider } = await import('@contexts/jobs');
          return {
            Component: () => (
              <JobsProvider>
                <Jobs />
              </JobsProvider>
            ),
          };
        },
      },
    ],
  },
  {
    path: appRoutes.jobPreview(':id'),
    lazy: async () => {
      const { Preview } = await import('@pages/jobs/preview');
      return {
        Component: () => <Preview />,
      };
    },
  },
  {
    path: appRoutes.job(':projectId', ':jobId'),
    lazy: async () => {
      return {
        Component: () => (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        path: [tenantsRoute.index, tenantsRoute.tenant()].join('/'),
        children: workflowsRoutes,
      },
      ...jobWorkflowsRoutes,
      {
        path: jobIdRoute.index,
        lazy: async () => {
          const { Job } = await import('@pages/jobs/_id');
          return {
            Component: () => (
              <ProtectedRoute>
                <Job />
              </ProtectedRoute>
            ),
          };
        },
        children: [
          {
            path: jobIdRoute.index,
            lazy: async () => {
              const { MainInformation } = await import('@pages/jobs/_id/mainInformation');
              return {
                Component: () => <MainInformation />,
              };
            },
          },
          {
            path: jobIdRoute.materials,
            lazy: async () => {
              const { Materials } = await import('@pages/jobs/_id/materials');
              return {
                Component: () => <Materials />,
              };
            },
          },
          {
            path: jobIdRoute.inventory,
            lazy: async () => {
              const { Inventory } = await import('@pages/jobs/_id/inventory');
              const { JobInventoryProvider } = await import('@contexts/job/inventory');
              return {
                Component: () => (
                  <CustomSettingGuard disabledBy="inventory_module_disabled" redirectTo="..">
                    <JobInventoryProvider>
                      <Inventory />
                    </JobInventoryProvider>
                  </CustomSettingGuard>
                ),
              };
            },
          },
          {
            path: jobIdRoute.documents,
            lazy: async () => {
              const { Documents } = await import('@pages/jobs/_id/documents');
              return {
                Component: () => <Documents />,
              };
            },
          },
          {
            path: jobIdRoute.questionnaire,
            lazy: async () => {
              const { Questionnaires } = await import(
                '@pages/jobs/_id/questionnaires/_questionaryId'
              );
              const { QuestionaryProvider } = await import('@contexts/questionary');
              return {
                Component: () => (
                  <QuestionaryProvider>
                    <Questionnaires />
                  </QuestionaryProvider>
                ),
              };
            },
          },
          {
            path: jobIdRoute.workProgress,
            element: <WorkProgress />,
          },
        ],
      },
    ],
  },
];
